import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { FACTURES_VIEW_ROLES } from '../../constants/roles';
import { LoadingGif, LoadingMessage } from './CommonStyles';

const FacturesRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
	const { user, isLoading } = useAuth();
	const location = useLocation();

	if (isLoading) {
		return (
			<LoadingMessage>
				<LoadingGif size="large" />
			</LoadingMessage>
		);
	}

	if (!user) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	const roles = user.roles as readonly string[];
	if (!FACTURES_VIEW_ROLES.some((r) => roles.includes(r))) {
		return <Navigate to="/" replace />;
	}

	return children;
};

export default FacturesRoute;